import CloseButtonIcon from "./CloseButtonIcon";
import { Context } from "../EditorContext";
import { useCallback, useContext } from "react";
import { useUpdate } from "ahooks";
import { toRGBA } from "../parser/utils";

export default ({ top = 0, right = 0}) => {
  const { state, shareRefs, notifySubscriber } = useContext(Context);

  const { root } = state;

  const {
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    size,
    strokeWidth,
    backgroundColor,
    color,
    borderColor,
  } = root.extraComponents.closeButton.data;

  const update = useUpdate();

  const updateSelectContent = useCallback(
    (data = {}) => {
      Object.assign(root.extraComponents.closeButton.data, data);
      update();
    },
    [root.extraComponents.closeButton, update]
  );

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      update();
      if (shareRefs.updateSelectContent) {
        shareRefs.updateSelectContent();
      }
      shareRefs.selectedNode = root.extraComponents.closeButton;
      shareRefs.updateSelectContent = updateSelectContent;
      notifySubscriber("NODE_SELECT");
    },
    [update, updateSelectContent]
  );

  const isSelectedNode =
    shareRefs.selectedNode &&
    root.extraComponents.closeButton.id === shareRefs.selectedNode.id;

  return (
    <div
      style={{
        position: "absolute",
        top,
        right,
        width: size,
        height: size,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        outline: isSelectedNode ? "#fc679a solid 2px" : "none",
      }}
      onClick={handleClick}
    >
      <div
        style={{
          backgroundColor: toRGBA(backgroundColor),
          borderRadius: "50%",
          display: "flex",
          width: size,
          height: size,
          border: `1px solid ${toRGBA(borderColor)}`
        }}
      >
        <CloseButtonIcon
          color={toRGBA(color)}
          size={size}
          strokeWidth={strokeWidth}
        />
      </div>
    </div>
  );
};
